module.exports = __webpack_public_path__ + "img/about-bio-1@2x.b04b4909.jpg";